import React from "react";
import { imgUrl } from "../utils/imgUrl";

export default function OrderCart({ e, i }) {
  return (
    <div key={i} className="row border-bottom py-3 ">
      <div className="col-2">
        <img
          src={imgUrl + e?.product?.images[0]?.name}
          alt="Beef Stack"
          className="rounded me-3"
        />
      </div>
      <div className="col-8">
        <h4 className="fs-md-4 fs-5">{e?.product?.name}</h4>
        <p className="fs-md-5 fs-6">{e?.product?.description}</p>
        {e?.ingredients?.map((ingredient, index) => (
          <p className="mt-2" key={index}>
            <strong>{ingredient?.ingredient_category?.name}:</strong>{" "}
            {ingredient?.ingredient_subcategory?.name}
          </p>
        ))}
      </div>
      <div className="col-2 text-end">
        <p style={{ textWrap: "nowrap" }}>${e?.total_price}</p>
        <p style={{ textWrap: "nowrap" }}>Qty: {e?.quantity}</p>
      </div>
    </div>
  );

  // <div className="d-flex align-items-center justify-content-between border-bottom py-3">
  //   <div className="d-flex align-items-center">
  //     <img
  //       src="https://via.placeholder.com/80"
  //       alt="Chicken Seekh"
  //       className="rounded"
  //       style={{ width: 80, height: 80, objectFit: "cover", marginRight: 15 }}
  //     />
  //     <div>
  //       <h6 className="mb-1" style={{ fontWeight: 500 }}>
  //         Chicken Seekh
  //       </h6>
  //       <p className="mb-0 text-muted" style={{ fontSize: 14 }}>
  //         Spicy | Raita | Extra Sauce
  //       </p>
  //     </div>
  //   </div>
  //   <div className="text-end">
  //     <p className="mb-1" style={{ fontSize: 16, fontWeight: 600 }}>
  //       $19.00
  //     </p>
  //     <p className="mb-0 text-muted" style={{ fontSize: 14 }}>
  //       Qty: 1
  //     </p>
  //   </div>
  // </div>

  // <div className="d-flex align-items-center justify-content-between py-3">
  //   <div className="d-flex align-items-center">
  //     <img
  //       src="https://via.placeholder.com/80"
  //       alt="Chicken Tikka"
  //       className="rounded"
  //       style={{ width: 80, height: 80, objectFit: "cover", marginRight: 15 }}
  //     />
  //     <div>
  //       <h6 className="mb-1" style={{ fontWeight: 500 }}>
  //         Chicken Tikka
  //       </h6>
  //       <p className="mb-0 text-muted" style={{ fontSize: 14 }}>
  //         Spicy | Raita | Extra Sauce
  //       </p>
  //     </div>
  //   </div>
  //   <div className="text-end">
  //     <p className="mb-1" style={{ fontSize: 16, fontWeight: 600 }}>
  //       $25.00
  //     </p>
  //     <p className="mb-0 text-muted" style={{ fontSize: 14 }}>
  //       Qty: 1
  //     </p>
  //   </div>
  // </div>
}
